// RefundUpdateStore
import {defineStore} from 'pinia'
import {ref} from 'vue';

export const useRefundUpdateStore = defineStore('RefundUpdateStore', () => { 
    const refund_changed = ref<number>(0); 
 
    function updateRefunds() : void {
        refund_changed.value++; 
    } 

    return {refund_changed, updateRefunds};
});


